<template>
  <div style="height: 500px">
    <img src="./Oven.jpg" height="45" />
    <h5>МВ210 101</h5>
    <small>Аналоговый ввод</small>
    <div class="m-1" v-if="shares">
      <span v-if="shares.online" class="badge bg-success">ONLINE</span>
      <span v-if="!shares.online" class="badge bg-danger">OFFLINE</span>
    </div>
    <hr />
    <div class="row" v-if="shares">
      <div class="col">
        <!-- <ul class="list-group"> -->
        <div
          v-for="(channel, index) of shares.adc"
          :key="id + 'UL' + index"
          class="d-flex justify-content-between align-items-center"
        >
          <div class="p-1">
            <span
              v-if="
                shares.adcErrors && !shares.adcErrors[index] && channel !== 0
              "
              class="badge mb-1 mt-1 bg-success"
              >{{ index + 1 }}</span
            >
            <span
              v-if="channel === 0 && !shares.adcErrors[index]"
              class="badge mb-1 mt-1 bg-secondary"
              >{{ index + 1 }}</span
            >
            <span
              v-if="shares.adcErrors[index]"
              class="badge mb-1 mt-1 bg-danger"
              >{{ index + 1 }}</span
            >
          </div>
          <div class="text-center p-1">{{ channel }}</div>
        </div>
        <!-- </ul> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pulsar1T",
  props: ["info", "shares", "id"],
};
</script>
<style scoped>
</style>
